import { Controller } from "@hotwired/stimulus";

const NAME_REQUIRED_MESSAGE = "Dish name is required.";
const NOTICE_MESSAGE = "Please update the highlighted fields.";

export default class extends Controller {
  static targets = [ "nameField", "nameError" ];

  connect() {
    this.hasAttemptedSubmit = false;
  }

  validate(event) {
    this.hasAttemptedSubmit = true;

    const nameValid = this.validateName();
    this.updateErrorNotice();

    if (nameValid) return;

    event.preventDefault();
    this.nameFieldTarget.focus();
  }

  handleFieldInput() {
    this.revalidateAfterSubmit();
  }

  handleFieldChange() {
    this.revalidateAfterSubmit();
  }

  revalidateAfterSubmit() {
    if (!this.hasAttemptedSubmit) return;

    this.validateName();
    this.updateErrorNotice();
  }

  validateName() {
    const valid = this.nameFieldTarget.value.trim().length > 0;
    this.toggleNameError(!valid);
    return valid;
  }

  toggleNameError(show) {
    this.nameFieldTarget.classList.toggle("ec-field-control--invalid", show);
    this.nameFieldTarget.setAttribute("aria-invalid", show ? "true" : "false");

    this.nameErrorTarget.textContent = show ? NAME_REQUIRED_MESSAGE : "";
    this.nameErrorTarget.classList.toggle("hidden", !show);
  }

  updateErrorNotice() {
    const notice = this.noticeElement();
    if (!notice) return;

    const message = this.nameErrorTarget.textContent.trim();
    if (!this.hasAttemptedSubmit || message.length === 0) {
      notice.textContent = "";
      notice.classList.add("hidden");
      return;
    }

    notice.textContent = NOTICE_MESSAGE;
    notice.classList.remove("hidden");
  }

  noticeElement() {
    if (this._noticeElement) return this._noticeElement;

    const existing = this.element.querySelector("[data-client-validation-notice]");
    if (existing) {
      this._noticeElement = existing;
      return existing;
    }

    const notice = document.createElement("p");
    notice.className = "ec-form-error-notice hidden";
    notice.dataset.clientValidationNotice = "true";
    notice.setAttribute("role", "alert");
    notice.setAttribute("aria-live", "polite");
    notice.setAttribute("aria-atomic", "true");
    this.element.prepend(notice);
    this._noticeElement = notice;
    return notice;
  }
}
